import React, { useEffect, useRef, useState } from 'react';
import { IFilter } from '../settings/FilterHooks';

interface Props {
  filters: IFilter[];
  onChangeFilter: (filterType: string, name: string, value: boolean) => void;
  selectAll: (currentFilters: IFilter[], value: boolean) => void;
}

export const CommunityFilterDropdown: React.FC<Props> = ({
  filters,
  onChangeFilter,
  selectAll
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const communityFilters = filters.filter(
    f => f.filterType === 'community' && f.name !== 'unknown / non-nettwerk'
  );

  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  if (communityFilters.length === 0) return null;

  const selected = communityFilters.filter(f => f.value);
  const allSelected = selected.length === communityFilters.length;
  const label =
    selected.length === 0
      ? 'No communities'
      : allSelected
      ? 'All communities'
      : selected.map(f => f.name).join(', ');

  return (
    <div className="relative inline-block" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="bg-white shadow rounded px-3 py-2 text-sm font-light flex items-center space-x-2 max-w-xs"
      >
        <span className="truncate">{label}</span>
        <svg className="w-3 h-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.39a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {open && (
        <div className="absolute left-0 mt-1 z-50 w-64 bg-white rounded shadow-lg max-h-80 overflow-y-auto">
          <label className="flex items-center px-3 py-2 border-b border-gray-100 cursor-pointer hover:bg-gray-50">
            <input
              type="checkbox"
              className="form-checkbox border border-black text-primary h-4 w-4"
              checked={allSelected}
              onChange={e => selectAll(communityFilters, e.target.checked)}
            />
            <span className="ml-2 text-sm font-medium">Select all</span>
          </label>
          {communityFilters.map(filter => (
            <label
              key={filter.name}
              className="flex items-center px-3 py-2 cursor-pointer hover:bg-gray-50"
            >
              <input
                type="checkbox"
                className="form-checkbox border border-black text-primary h-4 w-4"
                checked={filter.value}
                onChange={e => onChangeFilter('community', filter.name, e.target.checked)}
              />
              <span className="ml-2 text-sm font-light">{filter.name}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommunityFilterDropdown;
